import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { defineMessages } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';

import { makePath } from 'helpers/link-generation';
import When from 'components/When';
import { MANAGE_SERVICES_TAB } from 'constants/logic';
import Message from 'components/Message';

const messages = defineMessages({
  label: {
    id: 'manage-services.components.services-summary.label',
    defaultMessage: 'Services',
  },
  duration: {
    id: 'manage-services.components.services-summary.name',
    defaultMessage: '{duration, number} min',
  },
  missingServicesLink: {
    id: 'manage-services.components.services-summary.missing-services-link',
    defaultMessage: 'You have no associated services. <a>Add service</a>',
  },
});

const ServicesSummary = ({ services, venueId }) => (
  <div>
    <Message as="h6" className="grid__item 1/1 mb-r" message={messages.label} />
    <When predicate={_isEmpty(services)}>
      <Message
        message={messages.missingServicesLink}
        values={{
          a: text => (
            <Link to={makePath.manageServicesAdd({ venueId, tab: MANAGE_SERVICES_TAB.SERVICES })}>{text}</Link>
          ),
        }}
      />
    </When>

    {!_isEmpty(services) &&
      services.map(({ id, name: serviceName, duration }) => (
        <div key={id} className="grid__item 1/1">
          <p>
            {serviceName}
            <span className="text--ui60">
              {' | '}
              <Message message={messages.duration} values={{ duration }} />
            </span>
          </p>
        </div>
      ))}
  </div>
);

ServicesSummary.propTypes = {
  venueId: PropTypes.number,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      duration: PropTypes.number,
    })
  ),
};

export default ServicesSummary;
